import React, { useState, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, Col, Row } from 'antd';
import { testNumber } from '../scripts/utils';
import '@ant-design/compatible/assets/index.css';
import MoneyInput from '@iso/components/MoneyInput.js';
import Select, { SelectOption } from '@iso/components/uielements/select';
import { findObjIntoArrayByProp, testEmpty, formatMoney } from '@iso/lib/helpers/utility';

import { getLocalPaymentForms } from '@iso/containers/PDV/scripts/storePaymentForms';
import { getLocalPaymentConditions } from '@iso/containers/PDV/scripts/storePaymentConditions';

const Option = SelectOption;

export default function FinalizarVenda(props) {
    
    const refPaymentForms = useRef(null)
    const refPaymentConditions = useRef(null)

    const [index, setIndex] = useState(null)
    const [payment, setPayment] = useState({})
    const [reload, setReaload] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const [hasPaymentToEdit, setHasPaymentToEdit] = useState(false)

    const [paymentForms, setPaymentForms] = useState([]);
    const [paymentConditions, setPaymentConditions] = useState([]);

    const resetPayment = () => {

        let c = null, cN = '', p = null, pN = '', pFM ="", value = 0;

        if(props.settings?.payment_form) {
            p = props.settings?.payment_form;
            const pfi = findObjIntoArrayByProp(paymentForms, '_id', props.settings?.payment_form)
            if(pfi !== -1) {
                pN = paymentForms[pfi].name
                pFM = refPaymentForms.current[pfi].real_form;
            }

        }

        if(props.settings?.payment_condition) {
            c = props.settings?.payment_condition;
            const cond = findObjIntoArrayByProp(paymentConditions, '_id', props.settings?.payment_condition)
            if(cond !== -1)
                cN = paymentConditions[cond].name
        }

        value = props.currentOrder.payment.balance;

        setPayment({condiction:c, paymentForm: p, paymentFormName: pN, condictionName: cN, paymentFormMethod: pFM, value:value})
    }

    React.useEffect(() => {
        refPaymentForms.current = paymentForms;
    }, [paymentForms])
    
    React.useEffect(() => {
        refPaymentConditions.current = paymentConditions;
    }, [paymentConditions])

    React.useEffect(() => {

        getPaymentOptions(props.isOnline)

        setIndex(props.currentPaymentIdx);

        if(typeof props.currentPayment !== 'undefined' && props.currentPayment !== null) {
            setHasPaymentToEdit(true);
            setPayment({...props.currentPayment});
        }
        else
            resetPayment(); // props.currentOrder.payment.balance

        let doIncrementData = false;

        if(props.settings?.payment_form) {
            doIncrementData = true;
            setPayment((prev) => { return {...prev, paymentForm: props.settings?.payment_form } }); 
        }
        
        if(props.settings?.payment_condition) {
            doIncrementData = true;
            setPayment((prev) => { return {...prev, condiction: props.settings?.payment_condition } });
        }

        if(doIncrementData)
            setTimeout(() => {

                if(props.settings?.payment_form) {
                    setPayment((prev) => {
                        const pfi = findObjIntoArrayByProp(refPaymentForms.current, '_id', props.settings?.payment_form)
                        prev.paymentFormName = refPaymentForms.current[pfi].name
                        prev.paymentFormMethod = refPaymentForms.current[pfi].real_form;

                        return prev;
                    });    
                }

                if(props.settings?.payment_condition) {
                    setPayment((prev) => {
                        const cond = findObjIntoArrayByProp(refPaymentConditions.current, '_id', props.settings?.payment_condition)
                        prev.condictionName = refPaymentConditions.current[cond].name
                        return prev;
                    });
                }
            }, 1500);
    }, [props.currentOrder, props.currentPayment, props.currentPaymentIdx, props.isOnline, props.settings])

    const getPaymentOptions = async (isOnline) => {
        try {
            if(paymentConditions.length === 0) {
                setPaymentForms( await getLocalPaymentForms() )
                setPaymentConditions( await getLocalPaymentConditions() )
            }
        } catch (error) {}
    }

    const setPaymentToOrder = () => {
        if(payment.value > 0 && payment.condictionName !== undefined) {

            props.onChange('payment', payment);

            setTimeout(() => {
                resetPayment();
            }, 500);
        }
    }

    const finishOrderPayment = () => {
        setLoadingSave(true);
        props.finish('payment', null);
    }

    const savePayment = () => {
        props.onChange('payment', payment, index);
        resetPayment();
    }

    const removePayment = () => {
        props.remove('payment', payment, index);
        resetPayment();
    }

    const onChangeVal = (f, v) => {
        setPayment(prev => {

            prev[f] = v;

            if(typeof prev.key === 'undefined') 
                prev.key = uuidv4();

            if(typeof prev.value !== 'undefined')
                prev.value = testNumber(prev.value)

            if(f === 'paymentForm') {
                const pfi = findObjIntoArrayByProp(paymentForms, '_id', v)
                prev.paymentFormName = paymentForms[pfi].name
                prev.paymentFormMethod = paymentForms[pfi].real_form;
            }
            else if(f === 'condiction') {
                const cond = findObjIntoArrayByProp(paymentConditions, '_id', v)
                prev.condictionName = paymentConditions[cond].name
            }

            return prev;
        })

        setReaload(!reload)
    }

    return (
        <Row gutter={24} className='contentItemEditInputs'>
            <Col span={12}>Forma:</Col>
            <Col span={12}>
                <Select
                    value={ payment?.paymentForm }
                    className="ant-input fullWidth"
                    placeholder="Forma de pagamento"
                    onChange={ e => { onChangeVal('paymentForm', e) }}>
                        <Option key={'form001'} value={''}>Selecione a forma de pagamento</Option>
                        {paymentForms.map((forma) => {
                            return <Option key={forma._id} value={forma._id}>{forma.name}</Option>
                        })}
                </Select>
            </Col>
            <Col span={12}>Condição:</Col>
            <Col span={12}>
                <Select
                    className="ant-input fullWidth"
                    value={ payment?.condiction }
                    placeholder="Condição de pagamento"
                    onChange={ e => { onChangeVal('condiction', e) }}>
                        <Option key={'cond001'} value={''}>Selecione a condição</Option>
                        {paymentConditions.map(forma => {
                            return <Option key={forma._id} value={forma._id}>{forma.name}</Option>
                        })}
                </Select>
            </Col>
            <Col span={12}>Valor:</Col>
            <Col span={12}>
                <MoneyInput
                    name="value"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(payment.value, ''))}
                    onChange={(e) => onChangeVal('value', e.target.value ) }
                />
            </Col>
            <Col span={12}>Troco:</Col>
            <Col span={12}>
                <MoneyInput
                    disabled
                    name="change"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(props.currentOrder?.payment?.change, ''))}
                />
            </Col>
            <Col span={12}>Pago:</Col>
            <Col span={12}>
                <MoneyInput
                    disabled
                    name="paid"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(testEmpty(props.currentOrder?.payment?.paid, ''))}
                />
            </Col>
            <Col span={12}>Saldo:</Col>
            <Col span={12}>
                <MoneyInput
                    disabled
                    name="balance"
                    decimalScale={2}
                    placeholder="0,00"
                    className='ant-input textRight'
                    value={formatMoney(props.currentOrder?.payment?.balance)}
                />
            </Col>
            <Col span={12}>
                {
                    (typeof props.currentPayment !== 'undefined' && props.currentPayment !== null) ?
                        <Button onClick={savePayment} type="primary" className='fullWidth'>Salvar</Button>
                    : (
                        props.currentOrder?.payment?.paid >= props.currentOrder?.amount ?
                        <Button onClick={finishOrderPayment} loading={loadingSave} type="primary" className='fullWidth'>Finalizar</Button>
                        : <Button onClick={setPaymentToOrder} type="primary" className='fullWidth'>Confirmar</Button>
                    )
                }
            </Col>
            {
                hasPaymentToEdit ?
                    <Col span={ 6 }>
                        <Button onClick={removePayment} type="danger" className='fullWidth'>Remover</Button>
                    </Col>
                : <></>
            }
            <Col span={ hasPaymentToEdit ? 6 : 12}>
                <Button onClick={()=>props.cancel('payment')} type="danger" className='fullWidth'>Cancelar</Button>
            </Col>
        </Row>
    )
}